import { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../components/Footer";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";
import { useNavigate } from "react-router-dom";

function TopGame() {
    const [profile, setProfile] = useState(null);
    const [activeLevel, setActiveLevel] = useState(0);
    const [tabActive, setTabActive] = useState(0);
    const [profit, setProfit] = useState(null);
    const [percent, setPercent] = useState(0);
    const vipLevels = Array.from({ length: 11 }, (_, i) => i);
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    const navigate = useNavigate();
    const handleBackClick = () => {
        navigate(-1);
    };
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                setProfile(res.data.data);
                setActiveLevel(res.data.data.level);
                setTabActive(res.data.data.level);
            })
            .catch((err) => localStorage.removeItem("user"));
        axios.get(`${process.env.REACT_APP_API_URL}/profit/get`, {}).then((res) => {
            setProfit(res.data.data[0]);
        });
    }, []);
    useEffect(() => {
        if (profile && profit) {
            if (tabActive < 10) {
                const phantram = profile.tongnap / profit["nap" + (tabActive + 1)];
                setPercent(phantram * 100 > 100 ? 100 : Math.round(phantram * 100));
            } else {
                setPercent(0);
            }
        }
    }, [tabActive, profile, profit]);

    return (
        <>
            <div className="title-top">
                <div className="back" onClick={handleBackClick}>
                    <KeyboardArrowLeftOutlinedIcon />
                </div>
                <h1 className="title-h1">Đặc quyền VIP</h1>
            </div>
            <div className="main">
                <AnimatedPage>
                    <div className="vipcard">
                        <div class="vip-card-container">
                            <div class="vipcard_logo">
                                <img src={require(`../../img/vip${tabActive}.png`)} />
                            </div>
                            <div class="vip-card-level">VIP{tabActive}</div>
                            <div class="vip-card-desc">＊Tích luỹ thăng cấp kết toán vào 00:10 mỗi ngày</div>
                            <div class="vip-card-progress">
                                <div class="vip-card-progress__mark-bg">
                                    <div class="vip-card-progress__mark-val" style={{ width: percent + "%" }} data-level={percent + "%"}></div>
                                </div>
                                <div class="vip-card-progress__bg">
                                    <div class="vip-card-progress__value" style={{ width: percent + "%" }}></div>
                                </div>
                            </div>
                            <div class="vip-card-info">
                                {tabActive < 10 ? (
                                    <>
                                        {activeLevel > tabActive ? (
                                            <>
                                                <div class="vip-card-info__condition">
                                                    Cấp bậc hiện tại của bạn là <span class="--red">VIP{activeLevel}</span>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div class="vip-card-info__condition">
                                                    {/* Updated number formatting here */}
                                                    <span class="--red">{profile?.tongnap?.toLocaleString("vi-VN") || 0}</span>/
                                                    {profit && profit["nap" + (tabActive + 1)]?.toLocaleString("vi-VN")}
                                                </div>
                                                <div class="vip-card-info__growth">Tích luỹ lên cấp tiếp theo</div>
                                                <div>VIP{tabActive + 1}</div>
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <div class="vip-card-info__condition">
                                            {/* Updated number formatting here */}
                                            <span class="--red">{profile?.tongnap?.toLocaleString("vi-VN") || 0}</span>/Đã đạt cấp bậc cao nhất
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="base-tabs">
                        {vipLevels.map((level, index) => (
                            <>
                                {index != 0 && <div class="vip-tabs__item-divide"></div>}
                                <div key={level} className={`vip-tabs__item base-tabs__tab ${tabActive === level ? "active" : ""}`} onClick={() => setTabActive(level)}>
                                    VIP{level}
                                </div>
                            </>
                        ))}
                    </div>
                    <h1 className="vip-benefits-title">Phúc lợi VIP{tabActive}</h1>
                    <div className="vip-benefits-list">
                        <div class="vip-benefits-list__item">
                            <div class="vip-benefits-list__item-icon">
                                <img src={require(`../../img/icv1.png`)} />
                            </div>
                            <div class="vip-benefits-list__item-content">
                                <h2>Quà thăng hạng</h2>
                                {/* Updated number formatting here if it's a number, otherwise display text */}
                                <p>{(profit && profit["top" + tabActive]?.toLocaleString("vi-VN")) || "Không"}</p>
                            </div>
                        </div>
                        <div class="vip-benefits-list__item">
                            <div class="vip-benefits-list__item-icon">
                                <img src={require(`../../img/icv2.png`)} />
                            </div>
                            <div class="vip-benefits-list__item-content">
                                <h2>Quà sinh nhật</h2>
                                {/* Updated number formatting here if it's a number, otherwise display text */}
                                <p>{(profit && profit["v" + tabActive]?.toLocaleString("vi-VN")) || "Không"}</p>
                            </div>
                        </div>
                        <div class="vip-benefits-list__item">
                            <div class="vip-benefits-list__item-icon">
                                <img src={require(`../../img/icv3.png`)} />
                            </div>
                            <div class="vip-benefits-list__item-content">
                                <h2>Rút tiền trong</h2>
                                <p>{tabActive != 0 ? "3 phút" : "30 phút"}</p>
                            </div>
                        </div>
                        <div class="vip-benefits-list__item">
                            <div class="vip-benefits-list__item-icon">
                                <img src={require(`../../img/icv4.png`)} />
                            </div>
                            <div class="vip-benefits-list__item-content">
                                <h2>Tỉ lệ hoàn trả cao nhất</h2>
                                <p>{tabActive != 0 ? "2.5%" : "0%"}</p>
                            </div>
                        </div>
                    </div>
                </AnimatedPage>
            </div>
            <Footer />
        </>
    );
}

export default TopGame;